// ─── Mobile Money & Agency Banking French Translation Dictionary ────────────────
// This dictionary provides comprehensive French fallbacks for all Mobile Money features:
// - Float & SIM management, Top-Up modal, Cash Till, Multi-Currency portfolio
// - Agent POS Terminal, Cash-In, Cash-Out, Airtime, Bill Pay
// - Digital Ledger, Thermal POS Receipt printing, Audit trails
// - Shift Reconciliation, Daily audits, Discrepancies (Shortage/Surplus)
// - Customer Debts & Overdraft portfolios, Settlements
// - Expenses & Operating Outflows, CIT transport, rebalances
// - Financial Analytics, Executive statements, Volume & P&L

export const mobileMoneyFallbacks: Record<string, Record<string, string>> = {
  fr: {
    '% Rate': '% Taux',
    '(Active Logged-in User)': '(Utilisateur Actif Connecté)',
    '(Perfect ✓)': '(Parfait ✓)',
    '(Shortage)': '(Déficit)',
    '(Surplus)': '(Excédent)',
    '+ Record Expense': '+ Enregistrer une Dépense',
    '+ Record First Expense': '+ Enregistrer une Première Dépense',
    '1. Agent Operation Type': '1. Type d\'Opération Agent',
    '1. Select Operation': '1. Sélectionner l\'Opération',
    '2. Active Operator SIM': '2. SIM Opérateur Active',
    '2. Operator Account / SIM': '2. Compte Opérateur / SIM',
    '30 Days': '30 Jours',
    'ACTIVE': 'ACTIF',
    'AGENCY & COUNTER KIOSK': 'AGENCE & KIOSQUE DE GUICHET',
    'AIRTIME': 'RECHARGE AIRTIME',
    'AMOUNT': 'MONTANT',
    'Account Currency': 'Devise du Compte',
    'Account Status': 'Statut du Compte',
    'Accounts': 'Comptes',
    'Actifs': 'Actifs',
    'Action': 'Action',
    'Actions': 'Actions',
    'Actions & History': 'Actions & Historique',
    'Actions / Details': 'Actions / Détails',
    'Activate account': 'Activer le compte',
    'Active': 'Actif',
    'Active Cases': 'Dossiers Actifs',
    'Active Customers': 'Clients Actifs',
    'Active Debt': 'Dette Active',
    'Active Debtor Cases': 'Dossiers Débiteurs Actifs',
    'Active Debtor Clients': 'Clients Débiteurs Actifs',
    'Active Operator Accounts & SIM Cards': 'Comptes Opérateurs & Cartes SIM Actives',
    'Active Operator SIM Cards': 'Cartes SIM Opérateurs Actives',
    'Active Operators': 'Opérateurs Actifs',
    'Active Orders': 'Commandes Actives',
    'Active SIMs': 'SIMs Actives',
    'Active Shift': 'Shift Actif',
    'Active Unpaid Debt': 'Dette Active Impayée',
    'Actual Count': 'Comptage Réel',
    'Actual Physical Drawer Cash Count': 'Comptage Réel des Espèces du Tiroir',
    'Add Category': 'Ajouter une Catégorie',
    'Add Float SIM': 'Ajouter une SIM Flottant',
    'Add Mobile Money Operator': 'Ajouter un Opérateur Mobile Money',
    'Add New Branch': 'Ajouter une Nouvelle Agence',
    'Add New Category': 'Ajouter une Nouvelle Catégorie',
    'Add New Operator': 'Ajouter un Nouvel Opérateur',
    'Add Operator': 'Ajouter un Opérateur',
    'Add Operator Account': 'Ajouter un Compte Opérateur',
    'Add Operator SIM': 'Ajouter une SIM Opérateur',
    'Add Provider': 'Ajouter un Opérateur',
    'Add to Float Balance': 'Ajouter au Solde Flottant',
    'Add your MTN MoMo, Airtel Money, M-Pesa, Orange or Wave accounts.': 'Ajoutez vos comptes MTN MoMo, Airtel Money, M-Pesa, Orange ou Wave.',
    'Adjustment Type': 'Type d\'Ajustement',
    'Agency Banking / Bank': 'Services Bancaires d\'Agence / Banque',
    'Agency Banking, SIM Floats & Till Management': 'Banque d\'Agence, Flottants SIM & Gestion de Caisse',
    'Agent Commission': 'Commission Agent',
    'Agent Commission (% or Fixed)': 'Commission Agent (% ou Fixe)',
    'Agent Net Commission': 'Commission Nette Agent',
    'Agent Operating Expenses & Outflows': 'Dépenses d\'Exploitation & Décaissements Agent',
    'Agent POS Terminal': 'Terminal POS Agent',
    'Agent Share': 'Part Agent',
    'Agent Terminal POS': 'Terminal Caisse Agent POS',
    'Agent shift opened successfully!': 'Shift agent ouvert avec succès !',
    'Airtime': 'Recharge Airtime',
    'Airtime Recharge': 'Recharge Airtime (Crédit)',
    'Airtime Sales': 'Ventes Airtime (Crédit Téléphonique)',
    'Airtime Top-Up': 'Recharge Crédit (Airtime)',
    'Airtime Top-Up (Recharge)': 'Recharge Airtime (Crédit)',
    'All': 'Tout',
    'All Branches': 'Toutes les Agences',
    'All Categories': 'Toutes les Catégories',
    'All Currencies': 'Toutes les Devises',
    'All Operations': 'Toutes les Opérations',
    'All Operators': 'Tous les Opérateurs',
    'All Payment Methods': 'Toutes les Méthodes de Paiement',
    'All Shifts': 'Tous les Shifts',
    'All Statuses': 'Tous les Statuts',
    'All Transactions': 'Toutes les Transactions',
    'All World Currencies': 'Toutes les Devises Mondiales',
    'Already Paid': 'Déjà Payé',
    'Already Settled': 'Déjà Réglé',
    'Ambulance & Services d\'Urgence': 'Ambulance & Services d\'Urgence',
    'Amount': 'Montant',
    'Amount (USD)': 'Montant (USD)',
    'Amount is required': 'Le montant est requis',
    'Amount required': 'Montant requis',
    'Amount to Pay': 'Montant à Payer',
    'Amount:': 'Montant :',
    'Analytics': 'Analyses',
    'Apply Filter': 'Appliquer le Filtre',
    'Apply Filters': 'Appliquer les Filtres',
    'Appointments': 'Rendez-vous',
    'Assigned Branch': 'Agence Assignée',
    'Assigned Kiosk': 'Kiosque Assigné',
    'Audit & Closure': 'Audit & Clôture',
    'Audit & P&L': 'Audit & Pertes/Profits',
    'Audit & Reconciliation Report': 'Rapport d\'Audit & de Réconciliation',
    'Audit Currency': 'Devise d\'Audit',
    'Audit Details': 'Détails de l\'Audit',
    'Audit Ledger': 'Grand Livre d\'Audit',
    'Audit Logs': 'Journaux d\'Audit',
    'Audit Remarks': 'Remarques d\'Audit',
    'Audit Remarks / Discrepancy Reason': 'Remarques d\'Audit / Motif de l\'Écart',
    'Audit registry with expected cash, actual physical count, teller agent, and calculated variances': 'Registre d\'audit avec espèces attendues, comptage physique réel, caissier et écarts calculés',
    'Audit trails & P&L': 'Pistes d\'audit & Pertes/Profits',
    'Auto-fill system balances': 'Remplissage auto avec les soldes système',
    'Available': 'Disponible',
    'Average Debt / Client': 'Dette Moyenne / Client',
    'Average Transaction': 'Transaction Moyenne',
    'Average outstanding exposure': 'Exposition moyenne en cours',
    'Avg': 'Moy.',
    'BILL PAY': 'PAIEMENT FACTURE',
    'BILL_PAYMENT': 'PAIEMENT DE FACTURE',
    'Back': 'Retour',
    'Back to Dashboard': 'Retour au Tableau de Bord',
    'Balance': 'Solde',
    'Balance Check': 'Vérification de Solde',
    'Bank': 'Banque',
    'Bank / Agency': 'Banque / Agence',
    'Bank / Operator': 'Banque / Opérateur',
    'Bank Account': 'Compte Bancaire',
    'Bank Deposit': 'Dépôt Bancaire',
    'Bank Transfer & Mobile Money': 'Virement Bancaire & Mobile Money',
    'Bar & Orders': 'Bar & Commandes',
    'Bar & Restaurant Reports': 'Rapports Bar & Restaurant',
    'Bar POS': 'POS Bar',
    'Baseline': 'Point de Référence',
    'Baseline Alignment': 'Alignement de Base',
    'Batches & Expiry': 'Lots & Expiration',
    'Bill Pay': 'Paiement de Facture',
    'Bill Payment': 'Paiement de Facture',
    'Bill Payment (Utilities)': 'Paiement de Facture',
    'Bill Payment / Utilities': 'Paiement de Factures / Services Publics',
    'Billing & Escrow': 'Facturation & Séquestre',
    'Box Barcode Labels': 'Étiquettes Code-Barres Boîte',
    'Branch': 'Agence / Kiosque',
    'Branch / Kiosk Name': 'Nom de l\'Agence / Kiosque',
    'Branch / Location': 'Agence / Emplacement',
    'Branch Code': 'Code Agence',
    'Branch Short Code (e.g. KNK-01)': 'Code Court de l\'Agence (ex: KNK-01)',
    'Branch Structure Type': 'Type de Structure d\'Agence',
    'Branch name is required': 'Le nom de l\'agence est requis',
    'Branch registered successfully!': 'Agence enregistrée avec succès !',
    'Branches': 'Agences',
    'Brand Suppliers': 'Fournisseurs de Marque',
    'Businesses': 'Entreprises',
    'CASH': 'ESPÈCES',
    'CASH IN': 'DÉPÔT (CASH-IN)',
    'CASH OUT': 'RETRAIT (CASH-OUT)',
    'CASH PAID': 'ESPÈCES PAYÉES',
    'CASH TILL': 'Caisse Espèces',
    'CASH-IN': 'DÉPÔT (CASH-IN)',
    'CASH-OUT': 'RETRAIT (CASH-OUT)',
    'CIT Transport': 'Transport de Fonds (CIT)',
    'CODE': 'Code',
    'CUSTOMER': 'Client',
    'CUSTOMER CREDIT - UNPAID': 'CRÉDIT CLIENT - IMPAYÉ',
    'Calculating profit & loss statements...': 'Calcul des états de pertes et profits...',
    'Cancel': 'Annuler',
    'Cannot complete transaction: Insufficient Cash Till balance!': 'Impossible de finaliser la transaction : Solde de caisse espèces insuffisant !',
    'Cannot complete transaction: Insufficient Float SIM balance!': 'Impossible de finaliser la transaction : Solde de flottant SIM insuffisant !',
    'Cannot submit: Reference number already exists!': 'Impossible de valider : Le numéro de référence existe déjà !',
    'Care & Repair Orders': 'Commandes Soin & Réparation',
    'Carton Pre-Packs': 'Pré-Packs Cartons',
    'Cash': 'Espèces',
    'Cash & Floats': 'Espèces & Flottants',
    'Cash Discrepancy': 'Écart de Caisse',
    'Cash Drawer': 'Tiroir-Caisse',
    'Cash In': 'Dépôt (Cash-In)',
    'Cash Out': 'Retrait (Cash-Out)',
    'Cash Shortage': 'Déficit de Caisse',
    'Cash Surplus': 'Excédent de Caisse',
    'Cash Till': 'Caisse Espèces',
    'Cash Till (Physical)': 'Caisse Espèces (Physique)',
    'Cash Till Balance': 'Solde de la Caisse Espèces',
    'Cash Till Delta': 'Écart Caisse Espèces',
    'Cash Till Outflows (Physical)': 'Décaissements Caisse Espèces (Physique)',
    'Cash till <-> SIM floats': 'Caisse espèces <-> Flottants SIM',
    'Cash-In': 'DÉPÔT (CASH-IN)',
    'Cash-In (Deposit)': 'Dépôt (Cash-In)',
    'Cash-In (Deposits)': 'Dépôts (Cash-In)',
    'Cash-Out': 'RETRAIT (CASH-OUT)',
    'Cash-Out (Withdrawal)': 'Retrait (Cash-Out)',
    'Cash-Out (Withdrawals)': 'Retraits (Cash-Out)',
    'Categories': 'Catégories',
    'Category': 'Catégorie',
    'Category Display Name': 'Nom d\'Affichage de la Catégorie',
    'Category Name': 'Nom de la Catégorie',
    'Category System Code': 'Code Système de la Catégorie',
    'Category code is required': 'Le code de catégorie est requis',
    'Category created successfully!': 'Catégorie créée avec succès !',
    'Category label is required': 'Le libellé de catégorie est requis',
    'Category name is required': 'Le nom de la catégorie est requis',
    'Category removed!': 'Catégorie supprimée !',
    'Category required': 'Catégorie requise',
    'Category updated successfully!': 'Catégorie mise à jour avec succès !',
    'Clear': 'Effacer',
    'Clear Filter': 'Effacer le Filtre',
    'Click to change account currency': 'Cliquer pour changer la devise du compte',
    'Click to filter customer history': 'Cliquer pour filtrer l\'historique client',
    'Clinical Director Console': 'Console Directeur Clinique',
    'Clinical Staff': 'Personnel Clinique',
    'Close': 'Fermer',
    'Close Session': 'Fermer la Session',
    'Close Shift': 'Clôturer le Shift',
    'Close Window': 'Fermer la Fenêtre',
    'Closed': 'Clôturé',
    'Closed with cash shortage': 'Clôturé avec déficit de caisse',
    'Closed with cash surplus': 'Clôturé avec excédent de caisse',
    'Closing': 'Clôture',
    'Closing Cash': 'Espèces à la Clôture',
    'Closing Date': 'Date de Clôture',
    'Closing Float': 'Flottant de Clôture',
    'Closing Notes': 'Notes de Clôture',
    'Closure Log & Historical Audit': 'Journal de Clôture & Audit Historique',
    'Code': 'Code',
    'Code required': 'Code requis',
    'Comm': 'Comm.',
    'Commission': 'Commission',
    'Commission Amount': 'Montant de Commission',
    'Commission Mode': 'Mode de Commission',
    'Commission Mode *': 'Mode de Commission *',
    'Commission Rate': 'Taux de Commission',
    'Commission Rate (%)': 'Taux de Commission (%)',
    'Commission Rules': 'Règles de Commission',
    'Commission Type': 'Type de Commission',
    'Commission Value': 'Valeur de la Commission',
    'Commission Value *': 'Valeur de la Commission *',
    'Commissions': 'Commissions',
    'Complete History of Closed Sessions': 'Historique Complet des Sessions Clôturées',
    'Configuration': 'Configuration',
    'Confirm': 'Confirmer',
    'Confirm Branch Transfer': 'Confirmer le Transfert d\'Agence',
    'Confirm Float Funding': 'Confirmer l\'Alimentation du Flottant',
    'Confirm Payment': 'Confirmer le Paiement',
    'Confirm Rebalance Transfer': 'Confirmer le Transfert de Rééquilibrage',
    'Consolidated Multi-Currency Balances': 'Soldes Multi-Devises Consolidés',
    'Consolidated Multi-Currency Portfolio': 'Portefeuille Multi-Devises Consolidé',
    'Consultation': 'Consultation',
    'Contractors & Clients': 'Sous-Traitants & Clients',
    'Count': 'Nombre',
    'Count physical cash bills and coins in the cash drawer at start.': 'Comptez les billets et pièces physiques dans le tiroir-caisse au démarrage.',
    'Counted bills & coins': 'Billets & pièces comptés',
    'Counter Cash': 'Espèces au Guichet',
    'Counter Session': 'Session de Guichet',
    'Counter Session #': 'Session de Guichet #',
    'Create Category': 'Créer une Catégorie',
    'Created At': 'Créé le',
    'Credit': 'Crédit',
    'Credit & Debts': 'Crédit & Dettes',
    'Cumulative Volume': 'Volume Cumulé',
    'Currencies': 'Devises',
    'Currencies Tracked': 'Devises Suivies',
    'Currency': 'Devise',
    'Currency Configuration': 'Configuration des Devises',
    'Currency required': 'Devise requise',
    'Currency...': 'Devise...',
    'Current': 'Actuel',
    'Current Balance': 'Solde Actuel',
    'Current E-Float Balance': 'Solde E-Flottant Actuel',
    'Current Float Balance': 'Solde Flottant Actuel',
    'Current Session': 'Session Actuelle',
    'Current Shift Metrics': 'Métriques du Shift Actuel',
    'Custom Expense Category Name': 'Nom de Catégorie de Dépense Personnalisée',
    'Customer': 'Client',
    'Customer / Ref': 'Client / Réf.',
    'Customer Account Profile & Lifetime Summary': 'Profil Client & Résumé Historique',
    'Customer Debt / Credit': 'Dette / Crédit Client',
    'Customer Debts': 'Dettes Clients',
    'Customer Debts & Credits': 'Dettes & Crédits Clients',
    'Customer Debts & Overdrafts Portfolio': 'Portefeuille des Dettes & Découverts Clients',
    'Customer Deposits': 'Dépôts Clients',
    'Customer Fee': 'Frais Client',
    'Customer Full Name': 'Nom Complet du Client',
    'Customer History': 'Historique Client',
    'Customer Name': 'Nom du Client',
    'Customer Name (Optional)': 'Nom du Client (Optionnel)',
    'Customer Name:': 'Nom du Client :',
    'Customer Operations Log': 'Journal des Opérations Client',
    'Customer Phone': 'Téléphone Client',
    'Customer Phone *': 'Téléphone Client *',
    'Customer Phone Number': 'Numéro de Téléphone du Client',
    'Customer Phone:': 'Téléphone Client :',
    'Customer Portfolio & History': 'Portefeuille & Historique Client',
    'Customer Transaction History & Portfolio': 'Historique des Transactions & Portefeuille Client',
    'Customer Withdrawals': 'Retraits Clients',
    'Customers': 'Clients',
    'DEBT': 'Dette',
    'DEBT PAID': 'DETTE RÉGLÉE',
    'Daily Net Profit': 'Bénéfice Net Journalier',
    'Daily Volume Curve': 'Courbe de Volume Journalier',
    'Dashboard': 'Tableau de Bord',
    'Date': 'Date',
    'Date & Time': 'Date & Heure',
    'Date & Time:': 'Date & Heure :',
    'Date Range': 'Période',
    'Deactivate / Remove float account?': 'Désactiver / Supprimer le compte flottant ?',
    'Deactivate / Soft Remove': 'Désactiver / Suppression Logique',
    'Deactivate account': 'Désactiver le compte',
    'Debit': 'Débit',
    'Debt': 'Dette',
    'Debt & Status': 'Dette & Statut',
    'Debt Free': 'Sans Dette',
    'Debt Payment': 'Règlement de Dette',
    'Debt Portfolios': 'Portefeuilles de Dettes',
    'Debt Settlement History': 'Historique des Règlements de Dettes',
    'Debt settlement recorded successfully': 'Règlement de dette enregistré avec succès',
    'Debts': 'Dettes',
    'Debts & Credit': 'Dettes & Crédits',
    'Deducted directly from physical counter drawer': 'Déduit directement du tiroir caisse physique',
    'Default Currency': 'Devise par Défaut',
    'Define fixed or percentage commission rules for each operator SIM card (Airtel, MTN, Orange, M-Pesa, etc.). These rules will be applied automatically on your agency POS.': 'Définissez les règles de commissions fixes ou en pourcentage pour chaque carte SIM opérateur (Airtel, MTN, Orange, M-Pesa, etc.). Ces règles seront appliquées automatiquement sur le POS de votre agence.',
    'Delete': 'Supprimer',
    'Delete Category': 'Supprimer la Catégorie',
    'Delete Operator': 'Supprimer l\'Opérateur',
    'Delivery Notes': 'Bons de Livraison',
    'Delta': 'Écart',
    'Dependent / Sub-Agency (Shares Master E-Float with Siège)': 'Sous-Agence Dépendante (Partage le E-Flottant Principal avec le Siège)',
    'Deposit': 'Dépôt',
    'Deposit (Cash-In)': 'Dépôt (Cash-In)',
    'Description': 'Description',
    'Description & Remarks': 'Description & Remarques',
    'Destination Account (Credit)': 'Compte Destination (Crédit)',
    'Destination Branch': 'Agence de Destination',
    'Details': 'Détails',
    'Dettes & Crédits Client': 'Dettes & Crédits Clients',
    'Difference': 'Différence',
    'Digital': 'Numérique',
    'Digital Ledger': 'Grand Livre Numérique',
    'Discrepancy': 'Écart',
    'Discrepancy Amount': 'Montant de l\'Écart',
    'Dispense Medication': 'Délivrer Médicament',
    'Dispensing': 'Dispensation',
    'Display Audits': 'Afficher les Audits',
    'Distribution': 'Répartition',
    'Download': 'Télécharger',
    'Download CSV': 'Télécharger CSV',
    'Download PDF': 'Télécharger PDF',
    'E-FLOAT': 'E-FLOTTANT',
    'E-Float Charges': 'Frais de Flottant Électronique',
    'E-Float Charges & Liquidity': 'Frais de Flottant & Liquidités',
    'E-Float SIM': 'E-Floats SIM',
    'E-Floats & Cash Till': 'E-Floats & Caisse Guichet',
    'E-Floats SIM': 'E-Floats SIM',
    'E-Floats Total': 'Total E-Floats',
    'EXPENSE': 'Dépense',
    'Earned Commission': 'Commission Gagnée',
    'Edit': 'Modifier',
    'Edit Category': 'Modifier la Catégorie',
    'Edit Operator': 'Modifier l\'Opérateur',
    'Edit Operator Account': 'Modifier le Compte Opérateur',
    'Edit operator account': 'Modifier le Compte Opérateur',
    'Electronic SIM Float': 'Flottant SIM Électronique',
    'Employee': 'Employé',
    'Employees': 'Employés',
    'End Date': 'Date de Fin',
    'End of Day Audit & Shift Closure': 'Audit de Fin de Journée & Clôture de Shift',
    'Enter Amount': 'Saisir le Montant',
    'Enter Customer Name': 'Saisir le Nom du Client',
    'Enter Customer Phone': 'Saisir le Téléphone du Client',
    'Enter Reference': 'Saisir la Référence',
    'Enter counted physical cash amount...': 'Saisir le montant des espèces physiques comptées...',
    'Entered': 'Saisi',
    'Erreur lors de la sauvegarde de la commission': 'Erreur lors de la sauvegarde de la commission',
    'Error': 'Erreur',
    'Error loading float accounts': 'Erreur lors du chargement des comptes flottants',
    'Excel transaction report exported successfully!': 'Rapport de transactions Excel exporté avec succès !',
    'Exchange Rate': 'Taux de Change',
    'Execute Rebalance': 'Exécuter le Rééquilibrage',
    'Executive Dashboard': 'Tableau de Bord de Direction',
    'Executive Multi-Currency Financial Statement': 'État Financier Multi-Devises de Direction',
    'Expected': 'Attendu',
    'Expected Balance': 'Solde Attendu',
    'Expected Cash': 'Espèces Attendues',
    'Expense': 'Dépense',
    'Expense Amount': 'Montant de la Dépense',
    'Expense Category': 'Catégorie de Dépense',
    'Expense ID / Date': 'ID Dépense / Date',
    'Expense Records': 'Registres des Dépenses',
    'Expense successfully recorded!': 'Dépense enregistrée avec succès !',
    'Expenses': 'Dépenses',
    'Expenses & Outflows': 'Dépenses & Décaissements',
    'Expenses log exported to Excel CSV successfully': 'Journal des dépenses exporté au format Excel CSV avec succès',
    'Explain any cash shortage or surplus...': 'Expliquez tout déficit ou excédent d\'espèces...',
    'Explain any cash shortage, surplus, or adjustment...': 'Expliquez tout déficit, excédent ou ajustement de caisse...',
    'Export': 'Exporter',
    'Export CSV': 'Exporter CSV',
    'Export Excel': 'Exporter Excel',
    'Export to CSV / Excel': 'Exporter vers CSV / Excel',
    'External Bank': 'Banque Externe',
    'External Bank / Cash Deposit': 'Banque Externe / Dépôt Espèces',
    'Failed to change status': 'Échec du changement de statut',
    'Failed to close shift': 'Échec de la clôture du shift',
    'Failed to create category': 'Échec de la création de la catégorie',
    'Failed to deactivate operator account': 'Échec de la désactivation du compte opérateur',
    'Failed to execute float rebalance': 'Échec de l\'exécution du rééquilibrage du flottant',
    'Failed to load POS data': 'Échec du chargement des données POS',
    'Failed to load backend financial report analytics': 'Échec du chargement des analyses du rapport financier',
    'Failed to load customer debts': 'Échec du chargement des dettes clients',
    'Failed to load customer history': 'Échec du chargement de l\'historique client',
    'Failed to load mobile money expenses from backend': 'Échec du chargement des dépenses mobile money',
    'Failed to load transaction ledger': 'Échec du chargement du grand livre des transactions',
    'Failed to open shift': 'Échec de l\'ouverture du shift',
    'Failed to process transaction': 'Échec du traitement de la transaction',
    'Failed to record agent expense': 'Échec de l\'enregistrement de la dépense agent',
    'Failed to record expense': 'Échec de l\'enregistrement de la dépense',
    'Failed to record transaction': 'Échec de l\'enregistrement de la transaction',
    'Failed to register branch': 'Échec de l\'enregistrement de l\'agence',
    'Failed to register operator account': 'Échec de l\'enregistrement du compte opérateur',
    'Failed to remove category': 'Échec de la suppression de la catégorie',
    'Failed to save commission rule': 'Échec de l\'enregistrement de la règle de commission',
    'Failed to search customer': 'Échec de la recherche du client',
    'Failed to settle customer debt': 'Échec du règlement de la dette client',
    'Failed to transfer operator to branch': 'Échec du transfert de l\'opérateur vers l\'agence',
    'Failed to update category': 'Échec de la mise à jour de la catégorie',
    'Failed to update float balance': 'Échec de la mise à jour du solde flottant',
    'Failed to update operator account': 'Échec de la mise à jour du compte opérateur',
    'Fast Floating Action Modal': 'Action Flottante Rapide',
    'Fee': 'Frais',
    'Fee Amount': 'Montant des Frais',
    'Fee Type': 'Type de Frais',
    'Filter': 'Filtrer',
    'Filter by Branch': 'Filtrer par Agence',
    'Filter by Date': 'Filtrer par Date',
    'Filter by Operator': 'Filtrer par Opérateur',
    'Filter by Type': 'Filtrer par Type',
    'Filtered Sales Revenue': 'Revenu des Ventes Filtrées',
    'Final Cash Discrepancy': 'Écart Final de Caisse',
    'Final Physical Count of SIM E-Floats': 'Comptage Physique Final des E-Flottants SIM',
    'Finance': 'Finance',
    'Financial Analytics': 'Analyses Financières',
    'Financial Reports': 'Rapports Financiers',
    'Financial Statement': 'État Financier',
    'Financial Summary': 'Résumé Financier',
    'Financial report exported to Excel CSV successfully': 'Rapport financier exporté au format Excel CSV avec succès',
    'Fixed': 'Fixe',
    'Fixed (Cash Amount)': 'Fixe (Montant Espèces)',
    'Fixed Amount': 'Montant Fixe',
    'Float': 'Flottant',
    'Float Accounts': 'Comptes Flottants',
    'Float Audit': 'Audit du Flottant',
    'Float Balance': 'Solde Flottant',
    'Float Health': 'Santé du Flottant',
    'Float Management': 'Gestion du Flottant',
    'Float Operations': 'Opérations de Flottant',
    'Float Rebalance': 'Rééquilibrage de Flottant',
    'Float SIM': 'SIM Flottant',
    'Float SIM Delta': 'Écart Flottant SIM',
    'Float balance successfully funded and updated!': 'Solde flottant alimenté et mis à jour avec succès !',
    'Float transfer executed successfully!': 'Transfert de flottant exécuté avec succès !',
    'Floats': 'Flottants',
    'Floats SIM': 'SIMs Flottants',
    'Floor & Orders': 'Salle & Commandes',
    'Footwear Catalog': 'Catalogue Chaussures',
    'Frequent / Preferred Currencies': 'Devises Fréquentes / Préférées',
    'Frequent Currencies': 'Devises Fréquentes',
    'From Account': 'Compte Source',
    'From Cash Drawer (Till)': 'Depuis la Caisse Espèces (Tiroir)',
    'Full name...': 'Nom complet...',
    'Funding Source': 'Source de Financement',
    'Funds': 'Fonds',
    'Funds & Ledger': 'Fonds & Grand Livre',
    'General': 'Général',
    'Goods Receiving': 'Réception de Marchandises',
    'Gross Revenue': 'Revenu Brut',
    'Guests': 'Clients / Invités',
    'HIS Dashboard': 'Tableau de Bord SIH',
    'Headquarters': 'Siège',
    'Hide Balance': 'Masquer le Solde',
    'Historique': 'Historique',
    'Historique Clients': 'Historique Clients',
    'History': 'Historique',
    'History Notes': 'Notes d\'Historique',
    'Hospital Pharmacy Dashboard': 'Tableau de Bord Pharmacie Hospitalière',
    'Hospital Pharmacy POS': 'POS Pharmacie Hospitalière',
    'Hospital Reports': 'Rapports Hospitaliers',
    'Hospital Settings': 'Paramètres Hospitaliers',
    'ID': 'ID',
    'ID / Date': 'ID / Date',
    'INACTIVE': 'Inactif',
    'Immediate recovery target': 'Objectif de recouvrement immédiat',
    'In Cash Till': 'En Caisse Espèces',
    'In Progress': 'En Cours',
    'Inactive': 'Inactif',
    'Independent Kiosk (Standalone SIM & Float)': 'Kiosque Indépendant (SIM & Flottant Autonomes)',
    'Ingredients & Items': 'Ingrédients & Articles',
    'Initial Balance': 'Solde Initial',
    'Initial Cash': 'Espèces Initiales',
    'Initial Cash Float:': 'Flottant Espèces Initial :',
    'Initial Debt': 'Dette Initiale',
    'Initial Float Balance': 'Solde Flottant Initial',
    'Initial float + Transactions': 'Flottant initial + Transactions',
    'Initialize Float Operator Accounts': 'Initialiser les Comptes Opérateurs Flottants',
    'Inject funds into SIM': 'Injecter des fonds dans la SIM',
    'Inpatient Wards': 'Services d\'Hospitalisation',
    'Instant Counter Cash-In, Cash-Out, Airtime & Agency Transfers': 'Dépôts, Retraits, Airtime & Transferts d\'Agence Instantanés au Guichet',
    'Instant Deposits, Withdrawals, Airtime & Bill Payments for customers.': 'Dépôts, retraits, airtime et paiements de factures instantanés pour les clients.',
    'Insufficient Cash Till balance to disburse': 'Solde de caisse espèces insuffisant pour décaisser',
    'Insufficient Float SIM balance on': 'Solde de flottant SIM insuffisant sur',
    'Internal Transfer': 'Transfert Interne',
    'Inventory': 'Inventaire',
    'Inventory Overview': 'Aperçu de l\'Inventaire',
    'Inventory Reports': 'Rapports d\'Inventaire',
    'Kitchen & Menus': 'Cuisine & Menus',
    'Kitchen Display': 'Écran Cuisine',
    'Kitchen Stock': 'Stock Cuisine',
    'Label': 'Libellé',
    'Label required': 'Libellé requis',
    'Laboratory': 'Laboratoire',
    'Last 30 Days': '30 Derniers Jours',
    'Last 7 Days': '7 Derniers Jours',
    'Launch POS Terminal': 'Lancer le Terminal POS',
    'Ledger': 'Grand Livre',
    'Ledger & Audit': 'Grand Livre & Audit',
    'Lifetime Volume': 'Volume Cumulé Historique',
    'Liquidity Distribution': 'Répartition des Liquidités',
    'Live': 'En Direct',
    'Loading agent expenses from backend API...': 'Chargement des dépenses agent depuis l\'API backend...',
    'Loading expenses...': 'Chargement des dépenses...',
    'Loading reconciliation state...': 'Chargement de l\'état de réconciliation...',
    'Loading transactions...': 'Chargement des transactions...',
    'Loading...': 'Chargement...',
    'Log Expense': 'Enregistrer une Dépense',
    'Log operational expenses, CIT transport, rent & fees': 'Enregistrez les dépenses d\'exploitation, transport CIT, loyer & frais',
    'Log operational outflows': 'Enregistrer les décaissements opérationnels',
    'Main': 'Siège / Principal',
    'Main Branch': 'Agence Principale (Siège)',
    'Manage': 'Gérer',
    'Manage Categories': 'Gérer les Catégories',
    'Manage Floats': 'Gérer les Flottants',
    'Manage Operators': 'Gérer les Opérateurs',
    'Manage SIM Floats': 'Gérer les Flottants SIM',
    'Manage SIMs': 'Gérer les SIMs',
    'Mandatory audit before any counter operation': 'Audit obligatoire avant toute opération de guichet',
    'Mandatory audit before shift': 'Audit obligatoire avant ouverture de shift',
    'Matching Records': 'Enregistrements Correspondants',
    'Medications': 'Médicaments',
    'Menu Management': 'Gestion des Menus',
    'Menus & Recipes': 'Menus & Recettes',
    'Microfinance / MFI': 'Microfinance / IMF',
    'Mismatched Clearance': 'Compensation avec Écart',
    'MoMo Operations Agent': 'Agent d\'Opérations MoMo',
    'Mobile Money': 'Mobile Money',
    'Mobile Money & Agency Banking': 'Mobile Money & Services Bancaires d\'Agence',
    'Mobile Money (MTN/Airtel)': 'Mobile Money (MTN/Airtel)',
    'Mobile Money (MoMo)': 'Mobile Money (MoMo)',
    'Mobile Money Agent POS & Kiosk Terminal': 'Terminal POS & Kiosque Agent Mobile Money',
    'Mobile Money Dashboard': 'Tableau de Bord Mobile Money',
    'Mobile Money Operator': 'Opérateur Mobile Money',
    'Mobile Money POS Cashier Terminal': 'Terminal Caisse POS Mobile Money',
    'Mobile Money Teller / Operator': 'Caissier / Opérateur Mobile Money',
    'Mobile Money Treasury & Operator Float SIMs': 'Trésorerie Mobile Money & SIMs Flottants Opérateurs',
    'Montant': 'Montant',
    'Move Operator': 'Déplacer l\'Opérateur',
    'Move Operator to Another Branch': 'Déplacer l\'Opérateur vers une Autre Agence',
    'Move operator to another branch': 'Déplacer l\'opérateur vers une autre agence',
    'Multi-Currency': 'Multi-Devises',
    'Multi-Currency Float Management, Cash Till Rebalancing & SIM Fleet Operations': 'Gestion de Flottants Multi-Devises, Rééquilibrage de Caisse & Gestion de Flotte SIM',
    'N/A': 'N/D',
    'NET AGENT PROFIT': 'BÉNÉFICE NET AGENT',
    'NO SHIFT': 'AUCUN SHIFT',
    'Net Agent Earnings': 'Gains Nets Agent',
    'Net Commission': 'Commission Nette',
    'Net Profit': 'Bénéfice Net',
    'Net Revenue': 'Revenu Net',
    'Net Variation': 'Variation Nette',
    'Network Code': 'Code Réseau',
    'Network code is required': 'Le code réseau est requis',
    'New': 'Nouveau',
    'New Account': 'Nouveau Compte',
    'New Agent Expense recorded successfully!': 'Nouvelle dépense agent enregistrée avec succès !',
    'New Branch': 'Nouvelle Agence',
    'New Category': 'Nouvelle Catégorie',
    'New Operation': 'Nouvelle Opération',
    'New Operator': 'Nouvel Opérateur',
    'New Order / POS': 'Nouvelle Commande / POS',
    'New Shift': 'Nouveau Shift',
    'New Transaction': 'Nouvelle Transaction',
    'New transaction recorded in notebook!': 'Nouvelle transaction enregistrée dans le cahier !',
    'No Active Shift': 'Aucun Shift Actif',
    'No Active Shift: Please start your agent shift to record till operations.': 'Aucun Shift Actif : Veuillez ouvrir votre shift agent pour enregistrer les opérations de caisse.',
    'No Mobile Money Operator Configured': 'Aucun Opérateur Mobile Money Configuré',
    'No Mobile Money Operator Configured for this currency.': 'Aucun opérateur Mobile Money configuré pour cette devise.',
    'No Operator Configured': 'Aucun Opérateur Configuré',
    'No Recent Transactions Recorded': 'Aucune Transaction Récente Enregistrée',
    'No active operator accounts recorded.': 'Aucun compte opérateur actif enregistré.',
    'No active shift found': 'Aucun shift actif trouvé',
    'No agent expenses recorded for selected period': 'Aucune dépense agent enregistrée pour la période sélectionnée',
    'No currency configured for operators': 'Aucune devise configurée pour les opérateurs',
    'No daily profit data available for selected period': 'Aucune donnée de profit quotidien disponible pour la période sélectionnée',
    'No data': 'Aucune donnée',
    'No debt records in this category': 'Aucun dossier de dette dans cette catégorie',
    'No expenses data to export': 'Aucune donnée de dépenses à exporter',
    'No expenses recorded for this period': 'Aucune dépense enregistrée pour cette période',
    'No operator currencies found': 'Aucune devise d\'opérateur trouvée',
    'No operator share data for selected period': 'Aucune donnée de répartition opérateur pour la période sélectionnée',
    'No operators found': 'Aucun opérateur trouvé',
    'No shift history recorded yet': 'Aucun historique de shift enregistré pour l\'instant',
    'No specific note recorded.': 'Aucune note spécifique enregistrée.',
    'No transaction data to export': 'Aucune donnée de transaction à exporter',
    'No transactions available to export': 'Aucune transaction disponible à exporter',
    'No transactions found': 'Aucune transaction trouvée',
    'No transactions found for': 'Aucune transaction trouvée pour',
    'No transactions match your current filters': 'Aucune transaction ne correspond à vos filtres actuels',
    'No transactions recorded': 'Aucune transaction enregistrée',
    'Non-Medication Products': 'Produits Non-Médicamenteux',
    'Note (ex: Cash handed at till)': 'Note (ex: Espèces remises au guichet)',
    'Notes': 'Notes',
    'Notes & Collection Log': 'Notes & Journal de Recouvrement',
    'Notes / Reference': 'Notes / Référence',
    'Notes / Remarks': 'Notes / Remarques',
    'OPERATOR': 'Opérateur',
    'OPERATOR REF': 'Réf. Opérateur',
    'Observation / Note on Operation (Optional)': 'Observation / Note sur l\'Opération (Optionnel)',
    'Official Mobile Money Transaction Receipt': 'Reçu Officiel de Transaction Mobile Money',
    'Official Mobile Money Transaction Slip': 'Bordereau Officiel de Transaction Mobile Money',
    'Online': 'En Ligne',
    'Online Storefronts': 'Boutiques en Ligne',
    'Open': 'Ouvert',
    'Open Agent POS Terminal': 'Ouvrir le Terminal Agent POS',
    'Open Agent Shift': 'Ouvrir le Shift Agent',
    'Open Debt': 'Dette Ouverte',
    'Open Debts Only': 'Dettes Ouvertes Seulement',
    'Open New Shift': 'Ouvrir un Nouveau Shift',
    'Open Session': 'Ouvrir la Session',
    'Open Shift': 'Ouvrir le Shift',
    'Open Terminal POS': 'Ouvrir le Terminal POS',
    'Open customer credit portfolios': 'Portefeuilles de crédits clients en cours',
    'Opened At:': 'Ouvert le :',
    'Opening': 'Ouverture',
    'Opening Cash': 'Espèces à l\'Ouverture',
    'Opening Cash Float at Start': 'Flottant Espèces au Démarrage',
    'Opening Date': 'Date d\'Ouverture',
    'Opening E-Float Balances per Operator SIM': 'Soldes Flottants SIM Initiaux par Opérateur',
    'Opening Float': 'Flottant d\'Ouverture',
    'Opening Protocol': 'Protocole d\'Ouverture',
    'Opening cash float is required': 'Le flottant espèces d\'ouverture est requis',
    'Operating Expenses': 'Dépenses d\'Exploitation',
    'Operation': 'Opération',
    'Operation Type *': 'Type d\'Opération *',
    'Operations': 'Opérations',
    'Operator': 'Opérateur',
    'Operator / SIM': 'Opérateur / SIM',
    'Operator / SIM Account': 'Compte Opérateur / SIM',
    'Operator Account': 'Compte Opérateur',
    'Operator Account / Phone Number (Optional)': 'Numéro de Compte / Téléphone Opérateur (Optionnel)',
    'Operator Accounts & SIMs': 'Comptes & SIMs Opérateurs',
    'Operator Categories': 'Catégories d\'Opérateurs',
    'Operator Category': 'Catégorie d\'Opérateur',
    'Operator Category *': 'Catégorie d\'Opérateur *',
    'Operator Code': 'Code Opérateur',
    'Operator Commission Rules': 'Règles de Commission Opérateur',
    'Operator Name': 'Nom de l\'Opérateur',
    'Operator Name (e.g. MTN MoMo)': 'Nom de l\'Opérateur (ex: MTN MoMo)',
    'Operator Name (e.g. MTN MoMo) *': 'Nom de l\'Opérateur (ex: MTN MoMo) *',
    'Operator Provider': 'Fournisseur Opérateur',
    'Operator Ref': 'Réf. Opérateur',
    'Operator Ref ID': 'ID Réf. Opérateur',
    'Operator Reference / ID': 'Référence Opérateur / ID',
    'Operator SIM': 'SIM Opérateur',
    'Operator SIM Account *': 'Compte Opérateur SIM *',
    'Operator SIM E-Money Float Audit': 'Audit du Flottant Électronique SIM Opérateur',
    'Operator SIM Floats': 'Flottants SIM Opérateurs',
    'Operator Share': 'Part Opérateur',
    'Operator Short Code (e.g. MTN)': 'Code Court Opérateur (ex: MTN)',
    'Operator Short Code (e.g. MTN) *': 'Code Court Opérateur (ex: MTN) *',
    'Operator Yield': 'Rendement Opérateur',
    'Operator account deactivated successfully!': 'Compte opérateur désactivé avec succès !',
    'Operator account registered successfully!': 'Compte opérateur enregistré avec succès !',
    'Operator account status updated!': 'Statut du compte opérateur mis à jour !',
    'Operator account updated successfully!': 'Compte opérateur mis à jour avec succès !',
    'Operator name is required': 'Le nom de l\'opérateur est requis',
    'Operator rebalance & bank transfer charges': 'Frais de rééquilibrage opérateur & virement bancaire',
    'Operator successfully moved to the target branch!': 'Opérateur transféré avec succès vers l\'agence cible !',
    'Optional notes...': 'Notes optionnelles...',
    'Orders': 'Commandes',
    'Outflow Amount': 'Montant du Décaissement',
    'Outflows': 'Décaissements',
    'Outflows Recorded': 'Décaissements Enregistrés',
    'Outflows Recorded for selected period': 'Décaissements enregistrés pour la période sélectionnée',
    'Outstanding': 'En Cours',
    'Ouvrir Shift': 'Ouvrir le Shift',
    'Overview': 'Aperçu',
    'Owner Dashboard': 'Tableau de Bord Propriétaire',
    'PACS Imaging': 'Imagerie PACS',
    'PAID': 'PAYÉ',
    'PARTIAL': 'PARTIEL',
    'PDF': 'PDF',
    'POS': 'Point de Vente (POS)',
    'POS Cashier': 'Caisse POS',
    'POS Operation': 'Opération POS',
    'Paid': 'Payé',
    'Paid Amount': 'Montant Payé',
    'Partial': 'Partiel',
    'Patient Queue': 'File d\'Attente Patients',
    'Patient Records': 'Dossiers Patients',
    'Patients': 'Patients',
    'Pay': 'Payer',
    'Pay / Settle': 'Payer / Régler',
    'Payee': 'Bénéficiaire',
    'Payee / Beneficiary': 'Bénéficiaire',
    'Payee / Vendor': 'Bénéficiaire / Fournisseur',
    'Payment': 'Paiement',
    'Payment Method': 'Méthode de Paiement',
    'Payment Source': 'Source de Paiement',
    'Payment note...': 'Note de paiement...',
    'Payments': 'Paiements',
    'Payroll': 'Paie',
    'Percentage (%)': 'Pourcentage (%)',
    'Perfect reconciliation! Zero cash discrepancy.': 'Réconciliation parfaite ! Zéro écart de caisse.',
    'Perform Shift Closure': 'Effectuer la Clôture de Shift',
    'Perform daily cash audit, rebalance operator floats and generate shift closure reports.': 'Effectuez l\'audit de caisse quotidien, rééquilibrez les flottants opérateurs et générez les rapports de clôture.',
    'Period': 'Période',
    'Pharmacists': 'Pharmaciens',
    'Pharmacy Dashboard': 'Tableau de Bord Pharmacie',
    'Pharmacy POS': 'POS Pharmacie',
    'Physical Address / Location': 'Adresse Physique / Emplacement',
    'Physical Cash': 'Espèces Physiques',
    'Physical Cash Count': 'Comptage des Espèces Physiques',
    'Physical Cash Drawer Audit & Count': 'Audit & Comptage du Tiroir-Caisse Espèces',
    'Physical Cash Till': 'Caisse Espèces Physique',
    'Physical Count': 'Comptage Physique',
    'Physical Till Balance': 'Solde de Caisse Physique',
    'Physical cash count is required': 'Le comptage des espèces physiques est requis',
    'Physical till counting, baseline float alignment, and real-time discrepancy audit': 'Comptage de caisse physique, alignement du flottant de base et audit d\'écart en temps réel',
    'Platform Control': 'Contrôle de la Plateforme',
    'Please allow popups to print receipt': 'Veuillez autoriser les fenêtres pop-up pour imprimer le reçu',
    'Please enter a valid amount greater than 0': 'Veuillez saisir un montant valide supérieur à 0',
    'Please enter the amount': 'Veuillez saisir le montant',
    'Please enter the commission value': 'Veuillez saisir la valeur de la commission',
    'Please enter the paid amount': 'Veuillez saisir le montant payé',
    'Please select a valid operator': 'Veuillez sélectionner un opérateur valide',
    'Please select an operator': 'Veuillez sélectionner un opérateur',
    'Please select destination account': 'Veuillez sélectionner le compte destination',
    'Please select source account': 'Veuillez sélectionner le compte source',
    'Please type custom category name': 'Veuillez saisir le nom de la catégorie personnalisée',
    'Point of Sale': 'Point de Vente',
    'Prescriptions': 'Ordonnances',
    'Pricing Plans': 'Plans Tarifaires',
    'Principal Amount': 'Montant Principal',
    'Principal Amount:': 'Montant Principal :',
    'Print': 'Imprimer',
    'Print Receipt': 'Imprimer le Reçu',
    'Print Report': 'Imprimer le Rapport',
    'Print Summary': 'Imprimer le Résumé',
    'Print Ticket': 'Imprimer le Ticket',
    'Processed Volume': 'Volume Traité',
    'Procurement': 'Approvisionnement',
    'Product Categories': 'Catégories de Produits',
    'Products': 'Produits',
    'Products & Inventory': 'Produits & Inventaire',
    'Profit & Trends': 'Bénéfice & Tendances',
    'Public Utility / Bills': 'Services Publics / Factures',
    'Purchase Orders': 'Bons de Commande',
    'Quick Operations': 'Opérations Rapides',
    'REBALANCE': 'RÉÉQUILIBRAGE',
    'Ready': 'Prêt',
    'Real-time Cash Variance': 'Écart de Caisse en Temps Réel',
    'Real-time audit log of all deposits, cash-outs and commissions': 'Journal d\'audit en temps réel de tous les dépôts, retraits et commissions',
    'Real-time tracking of unpaid customer balances, partial recoveries, and settlement registry': 'Suivi en temps réel des soldes clients impayés, recouvrements partiels et registre des règlements',
    'Real-time transaction history, cumulative volume, and customer debt ledgers.': 'Historique des transactions en temps réel, volume cumulé et grand livre des dettes clients.',
    'Reason / Description': 'Motif / Description',
    'Rebalance': 'Rééquilibrer',
    'Rebalance Currencies & Floats': 'Rééquilibrer Devises & Flottants',
    'Rebalance Float': 'Rééquilibrer Flottant',
    'Rebalance Float / Cash Till Transfer': 'Rééquilibrage Flottant / Virement Caisse Guichet',
    'Receipt': 'Reçu',
    'Receipt ID': 'ID du Reçu',
    'Receipt ID:': 'ID du Reçu :',
    'Receipt note or purpose...': 'Note du reçu ou objet...',
    'Receiver Name (Optional)': 'Nom du Destinataire (Optionnel)',
    'Receiver Phone': 'Téléphone Destinataire',
    'Receiver Phone *': 'Téléphone Destinataire *',
    'Receiver name...': 'Nom du destinataire...',
    'Recent Transactions': 'Transactions Récentes',
    'Recipes': 'Recettes',
    'Recipes & Prep': 'Recettes & Préparation',
    'Reconcile & Close Agent Shift': 'Réconcilier & Clôturer le Shift Agent',
    'Reconciliation': 'Réconciliation',
    'Record': 'Enregistrer',
    'Record Agent Expense': 'Enregistrer une Dépense Agent',
    'Record Customer Debt Payment': 'Enregistrer un Règlement de Dette Client',
    'Record New Mobile Money Transaction': 'Enregistrer une Nouvelle Transaction Mobile Money',
    'Record Transaction': 'Enregistrer la Transaction',
    'Recorded Outflows': 'Décaissements Enregistrés',
    'Recorded Outflows for selected period': 'Décaissements enregistrés pour la période sélectionnée',
    'Records': 'Enregistrements',
    'Recovery': 'Recouvrement',
    'Reference': 'Référence',
    'Reference ID': 'ID de Référence',
    'Reference ID copied to clipboard!': 'ID de référence copié dans le presse-papier !',
    'Reference already exists!': 'Cette référence existe déjà !',
    'Refresh': 'Actualiser',
    'Refresh Data': 'Actualiser les Données',
    'Register': 'Enregistrer',
    'Register New Kiosk / Branch': 'Enregistrer une Nouvelle Agence / Kiosque',
    'Register New Operator Category': 'Enregistrer une Nouvelle Catégorie d\'Opérateur',
    'Register Operator': 'Enregistrer l\'Opérateur',
    'Register as Customer Debt / Credit (Unpaid)': 'Enregistrer comme Dette / Crédit Client (Non Payé)',
    'Registre Guichet Trésorerie • Instant Real-Time Ledger Sync': 'Registre Guichet Trésorerie • Synchronisation Instantanée en Temps Réel',
    'Reimbursed to till drawer': 'Remboursé dans le tiroir-caisse',
    'Remaining': 'Restant',
    'Remaining Balance': 'Solde Restant',
    'Remaining Unpaid Balance': 'Solde Restant Impayé',
    'Remaining to Pay': 'Reste à Payer',
    'Remarks & Manager Notes': 'Remarques & Notes du Manager',
    'Remove': 'Supprimer',
    'Remove Category': 'Supprimer la Catégorie',
    'Remove this category permanently?': 'Supprimer cette catégorie définitivement ?',
    'Reports': 'Rapports',
    'Reports & Analytics': 'Rapports & Analyses',
    'Required': 'Requis',
    'Reservations': 'Réservations',
    'Reset': 'Réinitialiser',
    'Reset All Filters': 'Réinitialiser Tous les Filtres',
    'Responsible Teller': 'Caissier / Agent Responsable',
    'Revenue': 'Revenu',
    'Règle de commission enregistrée avec succès pour cet opérateur !': 'Règle de commission enregistrée avec succès pour cet opérateur !',
    'SETTLED (PAID)': 'RÉGLÉ (PAYÉ)',
    'SETTLED IN FULL (PAID)': 'INTÉGRALEMENT RÉGLÉ (PAYÉ)',
    'SIM': 'SIM',
    'SIM Card': 'Carte SIM',
    'SIM Fleet': 'Flotte SIM',
    'SIM Float': 'Flottant SIM',
    'SIM Number / Till Agent': 'Numéro SIM / Agent Guichet',
    'SIM Operator': 'Opérateur SIM',
    'Sales': 'Ventes',
    'Sales Analytics': 'Analyses des Ventes',
    'Sales History': 'Historique des Ventes',
    'Sales Reports': 'Rapports des Ventes',
    'Save': 'Enregistrer',
    'Save & Log Expense': 'Enregistrer la Dépense',
    'Save & Register Branch': 'Enregistrer l\'Agence',
    'Save & Submit Transaction': 'Enregistrer & Valider la Transaction',
    'Save Category': 'Enregistrer la Catégorie',
    'Save Changes': 'Enregistrer les Modifications',
    'Save Commission Rule': 'Enregistrer la Règle de Commission',
    'Search': 'Rechercher',
    'Search by customer phone, name or reference (ex: 0900000000)...': 'Rechercher par tél., nom ou référence (ex: 0900000000)...',
    'Search by customer phone, name, ref...': 'Rechercher par tél., nom, réf...',
    'Search currency (e.g. USD, CDF, KES, EUR)...': 'Rechercher devise (ex: USD, CDF, KES, EUR)...',
    'Search currency...': 'Rechercher une devise...',
    'Search customer phone, name, transaction ref...': 'Rechercher tél., nom, réf. transaction...',
    'Search phone, customer name, reference...': 'Rechercher tél., nom client, référence...',
    'Search phone, name, ref...': 'Rechercher tél., nom, réf...',
    'Search...': 'Rechercher...',
    'Select Operator Account': 'Sélectionner le Compte Opérateur',
    'Select Operator Account *': 'Sélectionner le Compte Opérateur *',
    'Select a company user / agent...': 'Sélectionner un utilisateur / agent...',
    'Select destination account': 'Sélectionner le compte destination',
    'Select destination branch': 'Sélectionner l\'agence de destination',
    'Select expense category...': 'Sélectionner la catégorie de dépense...',
    'Select operator...': 'Sélectionner un opérateur...',
    'Select source account': 'Sélectionner le compte source',
    'Select source branch': 'Sélectionner l\'agence source',
    'Select source...': 'Sélectionner la source...',
    'Sender Name': 'Nom de l\'Expéditeur',
    'Sender Name (Optional)': 'Nom de l\'Expéditeur (Optionnel)',
    'Sender Phone': 'Téléphone de l\'Expéditeur',
    'Service Points': 'Points de Service',
    'Session Open': 'Session Ouverte',
    'Set Exact Balance': 'Définir le Solde Exact',
    'Set operator fee rates': 'Définir les taux de frais opérateur',
    'Settings': 'Paramètres',
    'Settled': 'Réglé',
    'Settlement': 'Règlement',
    'Shift': 'Shift',
    'Shift & Cash Reconciliation': 'Réconciliation de Shift & Caisse',
    'Shift & Cashier Summary': 'Résumé Shift & Caissier',
    'Shift Audit': 'Audit de Shift',
    'Shift Audit & Close': 'Audit & Clôture de Shift',
    'Shift Audit & Closure': 'Audit & Clôture de Shift',
    'Shift Closure': 'Clôture de Shift',
    'Shift Closure & Audit': 'Clôture & Audit de Shift',
    'Shift Closure & Audit in Progress': 'Clôture & Audit de Shift en Cours',
    'Shift En Cours': 'Shift en Cours',
    'Shift ID': 'ID du Shift',
    'Shift ID:': 'ID du Shift :',
    'Shift Inactive': 'Shift Inactif',
    'Shortage': 'Déficit',
    'Show Balance': 'Afficher le Solde',
    'Single source of truth for branch performance & profit breakdown': 'Source unique de vérité pour les performances d\'agence et ventilation du profit',
    'Single source of truth for counter expenses, CIT transport, and float rebalance fees': 'Source unique de vérité pour les dépenses de guichet, transport CIT et frais de flottant',
    'Size Converter': 'Convertisseur de Tailles',
    'Source Account (Debit)': 'Compte Source (Débit)',
    'Source Branch': 'Agence Source',
    'Source and destination accounts must be different': 'Les comptes source et destination doivent être différents',
    'Staff Management': 'Gestion du Personnel',
    'Staff Shifts': 'Shifts du Personnel',
    'Start Date': 'Date de Début',
    'Start a New Agent Shift': 'Démarrer un Nouveau Shift Agent',
    'Status': 'Statut',
    'Stock & Medications': 'Stock & Médicaments',
    'Stock & Operations': 'Stock & Opérations',
    'Stock & Shifts': 'Stock & Shifts',
    'Stock Catalog': 'Catalogue Stock',
    'Stock Inventory': 'Inventaire du Stock',
    'Stock Items': 'Articles en Stock',
    'Stock Movements': 'Mouvements de Stock',
    'Stock Transfers': 'Transferts de Stock',
    'Store Fulfillment': 'Traitement des Commandes Boutique',
    'Sum of agent commission earnings from all Cash-In deposits, Cash-Out withdrawals, and Airtime sales in active view': 'Somme des commissions d\'agent gagnées sur tous les dépôts, retraits et ventes d\'airtime affichés',
    'Suppliers': 'Fournisseurs',
    'Surplus': 'Excédent',
    'Sync': 'Synchroniser',
    'System': 'Système',
    'System Expected': 'Attendu par le Système',
    'System Expected Cash': 'Espèces Attendues par le Système',
    'System Expected Cash in Till': 'Espèces Attendues en Caisse par le Système',
    'System balances copied into audit fields!': 'Soldes du système copiés dans les champs d\'audit !',
    'TICKET #': 'TICKET #',
    'TOTAL TRANSACTION VALUE': 'VALEUR TOTALE DE TRANSACTION',
    'TYPE': 'TYPE',
    'Table Terms': 'Conditions des Tables',
    'Table Turn Reports': 'Rapports de Rotation des Tables',
    'Tables View': 'Vue des Tables',
    'Target Destination Branch': 'Agence de Destination Cible',
    'Telecom / Mobile Money': 'Télécom / Mobile Money',
    'Telecom, Bank, Utility': 'Télécom, Banque, Services',
    'Teller': 'Caissier',
    'Teller / Agent': 'Caissier / Agent',
    'Teller / Agent:': 'Caissier / Agent :',
    'Teller / Responsible Agent Name (Fuko User) *': 'Nom du Caissier / Agent Responsable (Utilisateur Fuko) *',
    'Teller name is required': 'Le nom du caissier est requis',
    'Terminal': 'Terminal',
    'Thank you for banking with us!': 'Merci pour votre confiance !',
    'The account will be deactivated from the active network.': 'Le compte sera désactivé du réseau actif.',
    'These amounts serve as baseline reference for discrepancy calculation upon closing.': 'Ces montants servent de référence de base pour le calcul des écarts lors de la clôture.',
    'This Month': 'Ce Mois',
    'This Week': 'Cette Semaine',
    'Till': 'Caisse',
    'Till Balance': 'Solde Caisse',
    'Till Closure & Shift Reconciliation': 'Clôture de Caisse & Réconciliation de Shift',
    'Till Currency': 'Devise de Caisse',
    'Till Expenses': 'Dépenses de Caisse',
    'To Account': 'Compte Destination',
    'Today': 'Aujourd\'hui',
    'Tool Rentals': 'Locations d\'Outils',
    'Top-Up': 'Recharge',
    'Top-Up Float': 'Alimenter Flottant',
    'Top-Up Operator Float Balance': 'Recharger le Solde Flottant Opérateur',
    'Total Available Capital': 'Capital Total Disponible',
    'Total Cash-In': 'Total Dépôts (Cash-In)',
    'Total Cash-In (Deposits)': 'Total Dépôts (Cash-In)',
    'Total Cash-Out': 'Total Retraits (Cash-Out)',
    'Total Commissions': 'Total des Commissions',
    'Total Debt Amount': 'Montant Total de Dette',
    'Total Liquid Capital': 'Capital Total Disponible',
    'Total Operating Outflows': 'Total des Décaissements d\'Exploitation',
    'Total Operations': 'Total des Opérations',
    'Total Outflows': 'Total Décaissements',
    'Total Recovered': 'Total Recouvré',
    'Total Transactions': 'Total des Transactions',
    'Total Unpaid': 'Total Impayé',
    'Total Unpaid Debt': 'Dette Totale Impayée',
    'Total Value': 'Valeur Totale',
    'Total Volume': 'Volume Total',
    'Track pending credits': 'Suivre les crédits en attente',
    'Transaction': 'Transaction',
    'Transaction Amount': 'Montant de la Transaction',
    'Transaction Details': 'Détails de la Transaction',
    'Transaction E-Receipt': 'Reçu Électronique de Transaction',
    'Transaction Fee': 'Frais de Transaction',
    'Transaction History Log': 'Historique des Transactions',
    'Transaction Ledger & Audit': 'Grand Livre & Audit des Transactions',
    'Transaction Remarks / Notes': 'Remarques / Notes de Transaction',
    'Transaction Type': 'Type de Transaction',
    'Transaction Type Donut': 'Répartition par Type de Transaction',
    'Transaction completed on credit without immediate cash collection': 'Transaction effectuée à crédit sans encaissement immédiat',
    'Transaction successfully processed and recorded!': 'Transaction traitée et enregistrée avec succès !',
    'Transactions': 'Transactions',
    'Transfer': 'Transfert',
    'Transfer (Send)': 'Transfert (Envoi)',
    'Transfer Amount & Currency': 'Montant & Devise du Transfert',
    'Transfer Reason / Notes': 'Motif du Transfert / Notes',
    'Transfer amount is required': 'Le montant du transfert est requis',
    'Transfer amount must be greater than zero': 'Le montant du transfert doit être supérieur à zéro',
    'Transfer current float balance with this operator': 'Transférer le solde flottant actuel avec cet opérateur',
    'Triage': 'Triage',
    'Try resetting date, operator, or type filters, or record a new transaction.': 'Essayez de réinitialiser les filtres de date, d\'opérateur ou de type, ou enregistrez une nouvelle transaction.',
    'Tx': 'Tx',
    'Type': 'Type',
    'UNPAID': 'NON PAYÉ',
    'Unknown Customer': 'Client Inconnu',
    'Unpaid': 'Non Payé',
    'Users': 'Utilisateurs',
    'VERIFIED TRANSACTION': 'TRANSACTION VÉRIFIÉE',
    'Verify Float SIM': 'Vérifier la SIM Flottant',
    'Verify virtual unit balances on each operator SIM card (MTN, Airtel, M-Pesa, Orange, Wave).': 'Vérifiez les soldes d\'unités virtuelles sur chaque carte SIM opérateur (MTN, Airtel, M-Pesa, Orange, Wave).',
    'View Details': 'Voir les Détails',
    'View E-Receipt Slip': 'Voir le Reçu Électronique',
    'View Full Ledger': 'Consulter le Grand Livre Complet',
    'View History': 'Voir l\'Historique',
    'View Ledger': 'Consulter le Grand Livre',
    'Visitors': 'Visiteurs',
    'Volume': 'Volume',
    'Walk-in Customer': 'Client de Passage',
    'Warning: This transaction reference ID already exists in records!': 'Attention : Cet ID de référence de transaction existe déjà dans les registres !',
    'Website': 'Site Web',
    'Website Hub': 'Centre Web',
    'Wholesale': 'Vente en Gros',
    'Withdrawal': 'Retrait',
    'Withdrawal (Cash-Out)': 'Retrait (Cash-Out)',
    'Yes, Remove': 'Oui, Supprimer',
    'Yesterday': 'Hier',
    'Yield': 'Rendement',
    'Yield Margin': 'Marge de Rendement',
    'Zero Debt': 'Zéro Dette',
    'Zero Debt ✓': 'Zéro Dette ✓',
    'active cases': 'dossiers actifs',
    'cases': 'dossiers',
    'e.g. 0700000000 or Till 19283': 'ex: 0700000000 ou Caisse 19283',
    'e.g. 500 (for 500 fixed) or 1.5 (for 1.5%)': 'ex: 500 (pour 500 fixe) ou 1.5 (pour 1.5%)',
    'e.g. Avenue du Commerce, Building B': 'ex: Avenue du Commerce, Bâtiment B',
    'e.g. BR-03, KNK-3': 'ex: BR-03, KNK-3',
    'e.g. Bank cash deposit or inter-branch float transfer': 'ex: Dépôt bancaire espèces ou virement de flottant inter-agences',
    'e.g. Bank slip #98219 or counter cash': 'ex: Bordereau bancaire #98219 ou espèces guichet',
    'e.g. CRYPTO, REMITTANCE': 'ex: CRYPTO, TRANSFERT',
    'e.g. Crypto Gateway, Remittance Agency': 'ex: Passerelle Crypto, Agence de Transfert',
    'e.g. Downtown Kiosk #3, Goma Branch': 'ex: Kiosque Centre-Ville #3, Agence Goma',
    'e.g. MTN Mobile Money, Airtel Money, Wave': 'ex: MTN Mobile Money, Airtel Money, Wave',
    'e.g. MTN, AIRTEL, MPESA, WAVE': 'ex: MTN, AIRTEL, MPESA, WAVE',
    'ex: Purpose, manager approval or special remarks...': 'ex: Objet, approbation manager ou remarques particulières...',
    'of': 'sur',
    'outflows': 'décaissements',
    'records': 'enregistrements',
    'to': 'à',
    'total transactions in view': 'total transactions affichées',
    'transactions': 'transactions',
    '📝 Notes / Remarks (Optional)...': '📝 Notes / Remarques (Optionnel)...',
    '🔒 CLOSED': '🔒 CLÔTURÉ',
    'Share on WhatsApp': 'Partager sur WhatsApp',
    'Share Receipt': 'Partager le Reçu',
    'Share via WhatsApp': 'Partager via WhatsApp',
    'WhatsApp E-Receipt': 'Reçu Électronique WhatsApp',
    'WhatsApp Receipt': 'Reçu WhatsApp',
    'Select Operator': 'Sélectionner un Opérateur',
    'Copy Receipt Text': 'Copier le Texte du Reçu',
    'Receipt copied to clipboard': 'Reçu copié dans le presse-papiers',
    'E-Receipt Details': 'Détails du Reçu Électronique',
    'Official Transaction Slip': 'Bordereau Officiel de Transaction',
    'Operator Breakdown': 'Répartition par Opérateur',
    'Quick Operator Filter': 'Filtre Rapide par Opérateur',
    'Click operator to filter transactions': 'Cliquer sur un opérateur pour filtrer les transactions',
    'No operator data available': 'Aucune donnée opérateur disponible',
    'Receipt Copied': 'Reçu Copié',
    'Transaction Receipt': 'Reçu de Transaction',
    'Total Collected': 'Total Encaissé',
    'Total Paid Out': 'Total Décaissé',
    'Thank you for your business!': 'Merci pour votre confiance !',
  }
};
